import { useEffect } from "react";
import { useLocation } from "react-router";

const PLACE_KEY = "hireos-last-place";

/** Settings: the sidebar becomes its section list while it is open. */
export function isSettings(pathname: string): boolean {
  return pathname === "/settings" || pathname.startsWith("/settings/");
}

/** Where Settings' Back goes: the last page read outside it. */
export function lastPlace(): string {
  try {
    return sessionStorage.getItem(PLACE_KEY) || "/";
  } catch {
    return "/";
  }
}

/** Keeps the last page read outside Settings, for Settings' Back. */
export function useRememberPlace() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (isSettings(pathname)) return;
    try {
      sessionStorage.setItem(PLACE_KEY, pathname + search);
    } catch {}
  }, [pathname, search]);
}
